import { Pipe, PipeTransform } from '@angular/core';
import {
  CheckActionEnum,
  CheckActionInfo,
} from '@qaroni-app/check/types/check-action.enum';

@Pipe({
  name: 'checksActionsName',
  standalone: false,
})
export class ChecksActionsNamePipe implements PipeTransform {
  transform(value: CheckActionEnum): string {
    if (value && Object.prototype.hasOwnProperty.call(CheckActionInfo, value)) {
      return CheckActionInfo[value].name;
    }

    return value;
  }
}
